import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal, ModalProps } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Global Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Global Workspaces
import {
    makeSelectQueryStringBooleanValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

interface OwnProps {
    param: string;
    children: React.ReactElement;
    modalProps?: ModalProps;
}

interface ConnectedProps {
    isOpen?: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = ConnectedProps & DispatchProps & OwnProps;

/**
 * A modal that is triggered by specific Query string parameters
 */
export class QueryStringModal extends React.PureComponent<Props> {
    handleClose = (): void => {
        const { param, ...props } = this.props;
        props.updateQueryString({
            [param]: undefined
        });
    };

    render(): React.ReactElement {
        const { isOpen, children, modalProps = {} } = this.props;
        return (
            <Modal
                size="fullscreen"
                open={isOpen}
                centered={false}
                onClose={this.handleClose}
                closeIcon
                {...modalProps}
            >
                {children}
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    isOpen: (state: any, props: any): boolean =>
        makeSelectQueryStringBooleanValue(props.param)(state, props)
});

export default connect(mapStateToProps, {
    updateQueryString
})(QueryStringModal);
